export var InfusionTypeEnum;
(function (InfusionTypeEnum) {
    InfusionTypeEnum["REPLICATE"] = "replicate";
    InfusionTypeEnum["AUGMENT"] = "augment";
    InfusionTypeEnum["CREATURE"] = "creature";
})(InfusionTypeEnum || (InfusionTypeEnum = {}));
export var InfusionModifierDataTypeEnum;
(function (InfusionModifierDataTypeEnum) {
    InfusionModifierDataTypeEnum["GRANTED"] = "granted";
    InfusionModifierDataTypeEnum["CLASS_LEVEL"] = "class-level";
    InfusionModifierDataTypeEnum["DAMAGE_TYPE_CHOICE"] = "damage-type-choice";
})(InfusionModifierDataTypeEnum || (InfusionModifierDataTypeEnum = {}));
export var InfusionItemDataRuleTypeEnum;
(function (InfusionItemDataRuleTypeEnum) {
    InfusionItemDataRuleTypeEnum["ITEM"] = "item";
    InfusionItemDataRuleTypeEnum["ARMOR_TYPE"] = "armor-type";
    InfusionItemDataRuleTypeEnum["WEAPON_CATEGORY"] = "weapon-category";
    InfusionItemDataRuleTypeEnum["GEAR_TYPE"] = "gear-type";
    InfusionItemDataRuleTypeEnum["WEAPON_PROPERTY"] = "weapon-property";
})(InfusionItemDataRuleTypeEnum || (InfusionItemDataRuleTypeEnum = {}));
